angular
  .module('capability-ng-poll')
  .factory(
    'dismissScheduledPollCommand',
    function dismissScheduledPollCommandDefinition($q: ng.IQService, $http: ng.IHttpService, defineCommand: any): void {
      return defineCommand(
        'dismissScheduledPollCommand',
        function dismissScheduledPollCommand(deferred: ng.IDeferred<any>, pollId: number): void {
          $http
            .put(`/poll/scheduled/${pollId}`, {
              status: 'DISMISSED'
            })
            .then(({ data }: any): void => {
              deferred.resolve(pollId);
            })
            .catch(({ data }: any): void => {
              deferred.reject(data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/commands/dismiss_scheduled_poll_command.ts